export const getRandomHexValue = (length = 6) => {
    const bytes = new Uint8Array(Math.ceil(length / 2));
    crypto.getRandomValues(bytes); // Uses Web Crypto API
    const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'))
        .join('')
        .slice(0, length)
        .toUpperCase();
    return hex;
};
export default getRandomHexValue;
